<template>
  <PageContainer>
    <template #body>
      <Toolbar />
    </template>
  </PageContainer>
</template>

<script>
import { PageContainer } from '@jumpcloud/ui-components';
import Toolbar from 'client/Pki/PkiCertificateDetails/PkiCertificateDetailsToolbar';

export default {
  name: 'PkiCertificateDetailsPage',

  components: {
    PageContainer,
    Toolbar,
  },
};
</script>
